import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import CreateIcon from '@material-ui/icons/Create'
import getConfig from 'next/config'

import GridColumn from './column.json'
import { DelayAPI } from '../../../api'
import DelayModal from './delay.modal.container'
import { GenerateFilterTerm } from '../../../utils'
import { Loading } from '../../../components/loading/loading.styled'
import { WrapperContent, ActionCell } from '../../../styles/global.styled'
import { Card, MasterHeader, MasterGrid, CodeCell } from '../../../components'

import { Colors } from '../../../styles'
import { LoadingContainer, ActionContainer } from './delay.styled'

const Delay = () => {
  const appSize = useSelector((state) => state.appReducer)
  const height = appSize.height - 190 > 455 ? appSize.height - 190 : 455
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 20,
    filter: [],
    sortable: true,
    filterable: true,
    filterString: '[]',
  })
  const [modal, setModal] = useState(false)
  const [detail, setDetail] = useState(false)
  const [edited, setEdited] = useState(false)
  const [deleted, setDeleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataDelay, setDataDelay] = useState([])
  const [dataItem, setDataItem] = useState(null)
  const [totalDelay, setTotalDelay] = useState(0)
  const [pending, setPending] = useState(false)
  const [firstLoad, setFirstLoad] = useState(true)
  const { publicRuntimeConfig } = getConfig()

  const delayRole = useSelector((state) =>
    state.usersLoginReducer.roleMapping.find((e) => e.activeName.includes('master-data/delay'))
  )

  const _getData = async (loading, { skip, take, filterString }) => {
    setLoading(loading)
    try {
      setPending(true)
      const { data, dataCount } = await DelayAPI.GetAllMasterDataDelay(skip, take, filterString)
      setDataDelay(data)
      setTotalDelay(dataCount)
      setPending(false)
    } catch (error) {
      setPending(false)
      console.log(error)
    }
    setLoading(false)
  }

  const _onDataStateChange = ({ data }) => {
    GenerateFilterTerm(data.filter, GridColumn)
    setDataState({
      ...dataState,
      ...data,
      filter: data.filter,
      filterString: GenerateFilterTerm(data.filter, GridColumn),
    })
  }

  useEffect(() => {
    const delay = setTimeout(() => {
      if(!firstLoad) {
        _getData(false, { ...dataState,
          filterString: GenerateFilterTerm(dataState.filter, GridColumn) })
      }
    }, publicRuntimeConfig.FILTER_TIMEOUT)
    return () => clearTimeout(delay)
  }, [dataState.filter])

  const _onPageChange = (event) => {
    setDataState({
      ...dataState,
      skip: event.page.skip,
      take: event.page.take,
    })

    _getData(false, {
      skip: event.page.skip,
      take: event.page.take,
      filterString: dataState.filterString,
    })
  }

  const _codeCell = ({ dataItem }) => (
    <CodeCell
      id='m-detail-btn'
      onClick={() => {
        setDataItem(dataItem)
        setModal(!modal)
        setDetail(!detail)
      }}
    >
      {dataItem.Delay_Code}
    </CodeCell>
  )

  useEffect(() => {
    _getData(true, dataState)
    setFirstLoad(false)
  }, [])

  useEffect(() => {
    if(!firstLoad) {
      _getData(false, dataState)
    }
  }, [modal, deleted])

  const _header = () => {
    return (
      <MasterHeader
        allowCreate={delayRole.allowCreate}
        title='MASTER DATA DELAY'
        buttonTitle='Add New'
        onClick={() => {
          setModal(!modal)
        }}
      />
    )
  }

  const _actionCell = ({ colSpan, dataItem }) => (
    <td>
      <ActionContainer
        id='m_dly_action_btn'
        onClick={() => setDataItem(dataItem)}
        colSpan={colSpan}
      >
        <ActionCell
          hidden={!delayRole.allowEdit}
          id='m-edit-btn'
          onClick={() => {
            setModal(!modal)
            setEdited(!edited)
          }}
        >
          <CreateIcon htmlColor={Colors.green} />
        </ActionCell>
        <ActionCell
          hidden={!delayRole.allowDelete}
          id='m-delete-btn'
          onClick={() => {
            setDeleted(!deleted)
          }}
        >
          <DeleteIcon htmlColor={Colors.black} />
        </ActionCell>
      </ActionContainer>
    </td>
  )

  const _grid = () => {
    return (
      <MasterGrid
        id='m_dly_grid'
        height={height}
        data={dataDelay}
        total={totalDelay}
        codeCell={_codeCell}
        dataState={dataState}
        gridColumn={
          !delayRole.allowEdit && !delayRole.allowDelete
            ? GridColumn.filter((e) => e.title !== 'Action')
            : GridColumn
        }
        actionCell={_actionCell}
        pageSizes={[20, 50, 100]}
        onPageChange={(e) => _onPageChange(e)}
        onDataStateChange={(e) => _onDataStateChange(e)}
        pending={pending}
      />
    )
  }

  const _clearModal = () => {
    setModal(false)
    setDetail(false)
    setEdited(false)
    setDeleted(false)
    setDataItem(null)
  }

  return (
    <WrapperContent>
      <Card>
        {_header()}
        {loading ? (
          <LoadingContainer height={height}>
            <Loading />
          </LoadingContainer>
        ) : (
          _grid()
        )}
        <DelayModal
          id='m_dly_mdl'
          modal={modal}
          edit={edited}
          detail={detail}
          data={dataItem}
          delete={deleted}
          setDeleted={setDeleted}
          setModal={() => _clearModal()}
        />
      </Card>
    </WrapperContent>
  )
}

export default Delay
